import { Table } from "reactstrap";
import { ExpandableProps } from "../../../../../../types/Tables";

const CustomExpandableComponent: React.FC<ExpandableProps> = ({ data }) => {
  return (
    <Table cellPadding={5} cellSpacing={0} border={0} style={{ paddingLeft: 50 }}>
      <tbody>
        <tr>
          <td>{"ID"}:</td>
          <td>{data.id}</td>
        </tr>
        <tr>
          <td>{"Full name"}:</td>
          <td>{data.name}</td>
        </tr>
        <tr>
          <td>{"Extra info"}:</td>
          <td>{"And any further details here (images etc)..."}</td>
        </tr>
      </tbody>
    </Table>
  );
};
export default CustomExpandableComponent;
